import {authorizationService} from './authorizationService'
import { store } from 'stateManagement/stores/store'
const serviceName = "/User";
const userInformationServiceName = "/UserInformation";


export function userService(http) {
    return {
        //#region Get Calls
        getUserBaseInformationAsync: (generalId) => {
            var data = { params: { "generalId": generalId } };
            return http.get(serviceName + "/GetTinyByGeneralId", data)
        },
        getUserBaseInformation: (userId) => {
            var parameter = { 
                UserId: userId 
            };
            return http.post(serviceName + "/GetUserBaseInformation", parameter)
        },
        getUserIntensitiveInformationAsync: async (personnelCode) => {            
            var data = { params: { "personnelCode": personnelCode } };
            return await http.get(serviceName + "/GetUserIntensitiveInformationAsync", data)
        },
        getUserProfileByUserId: (userId) => {
            var data = { params: { "userId": userId } };
            return http.get(serviceName + "/GetUserProfileByUserId", data)
        },
        getPresonnelDataForResumeByGeneralId: (generalId) => {
            var data = { params: { "generalId": generalId } };
            return http.get(serviceName + "/GetPresonnelDataForResumeByGeneralId", data)
        },
        getUserFullInformationAsync: (generalId) => {
            var data = { params: { "generalId": generalId } };
            return http.get(serviceName + "/GetFullByGeneralId", data)
        },
        getUserSpouseInformationAsync: (generalId) => {
            var data = { params: { "generalId": generalId } };
            return http.get(serviceName + "/GetSpouseInfoByGeneralId", data)
        },
        getTinyByPersonnelCodeAsync: async (personnelCode) => {
            var data = { params: { "personnelCode": personnelCode } };
            return await http.get(serviceName + "/GetTinyByPersonnelCodeAsync", data)
        },
        getUserChildrenInformationAsync: (generalId) => {
            var data = { params: { "generalId": generalId } };
            return http.get(serviceName + "/GetChildrenInfoByGeneralId", data)
        },
        getPresentUserGeneralInfo: () => {
            return store.getState().userState.user;
        },
        getUserByCostCenterCode: (costCenterCode) => {
            var data = { params: { "costCenterCode": costCenterCode } };
            return http.get(serviceName + "/GetPersonnelByCostCenter", data)
        },
        getUserByEmplacementCode: (costCenterCode) => {
            var data = { params: { "costCenterCode": costCenterCode } };
            return http.get(serviceName + "/GetPersonnelByEmplacement", data)
        },        
        getAllPresentStaffAsync: () => {
            return http.get(serviceName + "/GetAllPresentStaffAsync")
        },
        getAllPresentStaffExcelAsync: async () => {
            return await http.get(serviceName + "/GetAllPresentStaffExcelAsync", { responseType: "blob" });
        },
        getAllPersonnel: () => {
            return http.get(serviceName + "/GetAllPersonnel")
        },
        getAllSeperatedPersonnel: () => {
            return http.get(serviceName + "/getAllSeperatedPersonnel")
        },
        getUserBySearchedValue: (searchValue) => {
            var data = { params: { "value": searchValue } };
            return http.get(serviceName + "/SearchPersonnel", data)
        },
        getSystemGuests: () => {
            return http.get(serviceName + "/GetSystemGuests")
        },
        GetUserInformation: (userIds) => {
            var parameter = {
                UserIds: userIds
            }
            return http.post(serviceName + "/GetUserInformation", parameter)
        },
        getDisciplineEmployees: (discipline) => {
            var parameter = {
                DisciplineId: discipline
            };
            return http.post(serviceName + "/GetDisciplineEmployees", parameter);
        },
        getUsersGeneralInformation: personnelCodeList => {
            var parameter = { 
                personnelCodeList
            };
            return http.post(userInformationServiceName + "/GetUsersGeneralInformation",parameter);
        },
        getScheduleTest: (dateFrom, dateTo) => {
            var parameter = {
                MyDateTimeFrom: dateFrom,
                MyDateTimeTo : dateTo
            };

            return http.post("/Test/GetSchedule",parameter);
        },
        getDisciplineSupervisors: (disciplineId) => {
            var parameter = {
                DisciplineId: disciplineId
            };
            return http.post(serviceName + "/GetDisciplineSupervisors", parameter);
        },
        // getlist: () => {
        //     return userAuthorizationService.getCurrentUserRoles
        // }
        authorizationService:  authorizationService
        //#endregion 

        //#region Post Calls
        // getPersonnelPresencStatus: (data) => {
        //     return http.post(serviceName + "/PostPersonnelPresencStatus", data)
        // }
        //#endregion


    }
}

